import { base_colorAction, grey200, white100 } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { transition_slow } from 'ext-ui/style/transitionSpeeds'
import { css } from 'styled-components'

export default css`
  &.LargePill {
    display: flex;
    gap: ${spacing(4)};
    align-items: center;
    justify-content: space-between;

    padding: ${spacing(4)} ${spacing(5)};
    border: 1px solid ${base_colorAction};
    border-radius: 16px;
    background-color: ${white100};
    transition: background-color ${transition_slow} ease-in-out;

    &.interactable:hover {
      cursor: pointer;
      background-color: ${grey200};
    }

    & .icon-wrapper {
      flex: 0 0 auto;
    }
  }
`
